function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ChoiceTemplate = require('./choosecard.template');
var SaitoOverlay = require('./../../../../lib/saito/ui/saito-overlay/saito-overlay');
var ChoiceOverlay = /*#__PURE__*/function () {
  function ChoiceOverlay(app, mod) {
    _classCallCheck(this, ChoiceOverlay);
    this.app = app;
    this.mod = mod;
    this.cards = null;
    this.title = null;
    this.is_visible = false;
    this.overlay = new SaitoOverlay(app, mod, false, true, false);
    this.overlay.clickBackdropToClose = false;
  }
  return _createClass(ChoiceOverlay, [{
    key: "hide",
    value: function hide() {
      this.is_visible = false;
      this.overlay.hide();
    }
  }, {
    key: "render",
    value: function render() {
      var _deck$card, _deck$card2;
      var card1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var card2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var stage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      this.is_visible = true;
      var twilight_self = this.mod;
      var ui_self = this;
      var deck = this.mod.returnAllCards(true);
      var msg = 'Choose Card for Mid-War';
      if (stage == 'latewar') {
        msg = 'Choose Card for Mid-War';
      }
      var options = [];
      if ((_deck$card = deck[card1]) !== null && _deck$card !== void 0 && _deck$card.name) {
        options.push({
          id: card1,
          label: deck[card1].name
        });
      }
      if ((_deck$card2 = deck[card2]) !== null && _deck$card2 !== void 0 && _deck$card2.name) {
        options.push({
          id: card2,
          label: deck[card2].name
        });
      }
      this.overlay.show(ChoiceTemplate(this.mod, card1, card2, stage));
      twilight_self.game.status = msg;
      twilight_self.hud.updateStatus(twilight_self.game.status);
      twilight_self.hud.updateCards([]);
      twilight_self.hud.updateMenu(options);
      $('.option').off();
      $('.option').on('click', function () {
        var action = $(this).attr('id');
        if (stage == 'latewar') {
          twilight_self.addMove('add_latewar_card_to_deck\t' + action);
        } else {
          twilight_self.addMove('add_midwar_card_to_deck\t' + action);
        }
        twilight_self.endTurn();
        twilight_self.game.status = 'waiting for opponent to choose...';
        twilight_self.hud.updateStatus(twilight_self.game.status);
        twilight_self.hud.updateMenu([]);
        twilight_self.hud.updateCards([]);
        ui_self.hide();
      });
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {}
  }]);
}();
module.exports = ChoiceOverlay;